import type { CSSProperties } from "react";

/**
 * An image's width / height once it has loaded, or `null` for a size the browser could not
 * report (an empty or broken image). The hero and the logo size their boxes from it in CSS.
 */
export function naturalRatio(image: { naturalWidth: number; naturalHeight: number }): number | null {
  const { naturalWidth, naturalHeight } = image;
  return naturalWidth > 0 && naturalHeight > 0 ? naturalWidth / naturalHeight : null;
}

/** Inline style handing `ratio` to the stylesheet as the custom property `name`, if known. */
export function ratioStyle(name: `--${string}`, ratio: number | null): CSSProperties | undefined {
  if (ratio === null) {
    return undefined;
  }
  const style: CSSProperties = { [name]: ratio };
  return style;
}
